module.exports = {
  "id": "drive",
  "color": "pink",
  "title": "drive",
  "info": [
    {
      "text": "Drive a piece like a vehicle",
      "image": "provision/glitches/drive/drive.gif"
    }
  ],
  "icon": "rocket",
  "category": "keyboard",
  "searchTags": ["motion","walk","turn","steer","car","spaceship","locomote"],
  "exposedVariables": [
    {
      "spriteName": "$glitch_target",
      "variableName": "thruster force",
      "tooltip":"Set the amount of force the piece will move forward",
      "input": {
        "type": "slider",
        "options": [],
        "min": "0",
        "max": "20",
        "step": ".1"
      },
      "value": "5"
    },
    {
      "spriteName": "$glitch_target",
      "variableName": "turn speed",
      "tooltip":"Set the speed the piece will turn",
      "input": {
        "type": "slider",
        "options": [],
        "min": "0",
        "max": "30",
        "step": ".1"
      },
      "value": "5"
    },
    {
      "spriteName": "$glitch_target",
      "variableName": "thrust key",
      "tooltip":"Set the keyboard key that will make the piece move forward",
      "input": {
        "type": "key",
        "options": [],
        "min": -999,
        "max": 999
      },
      "value": "up arrow"
    },
    {
      "spriteName": "$glitch_target",
      "variableName": "left key",
      "tooltip":"Set the keyboard key that will make the piece move left",
      "input": {
        "type": "key",
        "options": [],
        "min": -999,
        "max": 999
      },
      "value": "left arrow"
    },
    {
      "spriteName": "$glitch_target",
      "variableName": "right key",
      "tooltip":"Set the keyboard key that will make the piece move right",
      "input": {
        "type": "key",
        "options": [],
        "min": -999,
        "max": 999
      },
      "value": "right arrow"
    }
  ],
  "codeImage": "provision/glitches/drive/drive.png",
  "code": null,
  "zip": null,
  "sb3": null
};